import LocalizationEntity from '../../../../../../domain/entities/localization.entity';

const LocalizationList: LocalizationEntity[] = [
    {
        name: 'english',
        code: 'en',
        dictionary: {},
        image: 'https://cdn.countryflags.com/thumbs/united-states-of-america/flag-round-250.png'
    },
    {
        name: 'spanish',
        code: 'es',
        dictionary: {},
        image: 'https://cdn.countryflags.com/thumbs/spain/flag-round-250.png'
    }
];

export default LocalizationList;